import React, { useEffect } from 'react'
import { Route, useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

import { APP_ROUTES } from '../../constants'
import { useUserHasPermissions } from '../../hooks'
import { permissionsPropType } from '../../prop-types'

const PermissionRoute = ({ permissions, component: Component, ...rest }) => {
  const hasPermission = useUserHasPermissions(permissions)
  const history = useHistory()

  useEffect(() => {
    if (!hasPermission) {
      history.push(APP_ROUTES.INGREDIENTS.link)
    }
  }, [history, hasPermission])

  return <Route {...rest} component={Component} />
}

PermissionRoute.propTypes = {
  permissions: permissionsPropType.isRequired,
  component: PropTypes.elementType.isRequired,
}

export default PermissionRoute
